(() => {
  const SELECTOR = '[data-hgp-complementary-add]';

  async function addComplementaryProduct(button) {
    if (button.disabled || button.dataset.loading === 'true') return;

    const variantId = Number(button.dataset.variantId);
    const label = button.querySelector('[data-hgp-add-label]');

    if (!variantId || !label) return;

    const originalLabel = label.textContent;

    button.dataset.loading = 'true';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    label.textContent = 'Adding…';

    try {
      const root =
        window.Shopify?.routes?.root ||
        '/';

      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1
            }
          ]
        })
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(
          result.description ||
          result.message ||
          'The product could not be added.'
        );
      }

      label.textContent = '✓ Added';
      button.classList.add('is-added');
      const cartDrawer = document.getElementById('Cart-Drawer');

if (cartDrawer && typeof cartDrawer.open === 'function') {
  cartDrawer.open();
}

      /*
       * These events give Pinnacle a chance to refresh its cart interface.
       * We will test whether the theme responds to either event.
       */
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: {
            source: 'complementary-products',
            product: result
          }
        })
      );

      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          bubbles: true,
          detail: {
            source: 'complementary-products',
            product: result
          }
        })
      );

      window.setTimeout(() => {
        label.textContent = originalLabel;
        button.classList.remove('is-added');
        button.disabled = false;
        button.dataset.loading = 'false';
        button.removeAttribute('aria-busy');
      }, 2000);
    } catch (error) {
      console.error('Complementary product add error:', error);

      label.textContent = 'Try again';
      button.classList.add('has-error');

      window.setTimeout(() => {
        label.textContent = originalLabel;
        button.classList.remove('has-error');
        button.disabled = false;
        button.dataset.loading = 'false';
        button.removeAttribute('aria-busy');
      }, 2000);
    }
  }

  document.addEventListener('click', event => {
    const button = event.target.closest(SELECTOR);

    if (!button) return;

    event.preventDefault();
    addComplementaryProduct(button);
  });
})();